module.exports = __webpack_public_path__ + "img/service-icon.24ecc241.png";